/* angular:styles/component:css;006746b5da6fe8e1be06da9a19f46310a80848ddaedbf92770f5f406f67f3b78;/app/src/app/shared/animations/global-loader.component.ts */
.center-loader {
  display: flex;
  justify-content: center;
}
.bigger-font {
  font-size: 20px !important;
}
.content-height {
  margin-top: -40px;
}
/*# sourceMappingURL=global-loader.component.css.map */
